import vinh_phu from "../../../assets/images/vinh_phu.svg";
import { Divider } from "@mui/material";

export default function BusinessStrategic() {
  return (
    <div className="w-full bg-[#f8ffff] lg:px-[120px] lg:py-[40px]">
      <div className="container mx-auto p-3 w-full">
        <div className="w-full flex flex-col gap-2 lg:flex-col lg:items-center lg:justify-center lg:gap-2">
          <p className="text-xl md:text-2xl lg:text-3xl text-[#033F6A] font-semibold">
            Đối tác chiến lược
          </p>
          <p className="text-sm md:text-base text-[#333333] font-normal">
            Chúng tôi hợp tác với các tổ chức, doanh nghiệp hàng đầu để cung cấp
            các giải pháp toàn diện và hiệu quả nhất
          </p>
        </div>

        <div className="mt-4 block lg:hidden">
          <Divider />
        </div>
        <div className="w-full flex flex-col gap-6 lg:flex-row lg:mt-8 lg:items-center lg:gap-5">
          <div className="w-full h-[91px] lg:w-[600px] lg:h-[200px]  lg:shadow-custom lg:rounded-full lg:flex lg:items-center lg:justify-center mt-4 rounded-[20px] flex items-center justify-center border border-solid border-[#F1F0F0] bg-white">
            <img src={vinh_phu} alt="vp" className="max-w-full h-auto" />
          </div>
          <div>
            <p className="text-base md:text-lg lg:text-xl font-semibold text-[#1375B7]">
              CÔNG TY CỔ PHẦN THƯƠNG MẠI NGÔI SAO VĨNH PHÚ
            </p>
            <p className="text-sm md:text-base text-[#333333] font-normal">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ac
              congue elit. Pellentesque quis feugiat ex. Pellentesque ac elit at
              quam porttitor mollis. Aliquam pretium vitae lectus quis pretium.
              Vestibulum vitae finibus turpis. Nulla venenatis vulputate velit
              eget lobortis. Phasellus cursus posuere nunc, et malesuada mauris
              porta a. Nunc semper odio eros, non ultrices lorem posuere eget.
              Curabitur tempus odio non sagittis posuere. Pellentesque in
              posuere ipsum, interdum cursus lectus.{" "}
            </p>
          </div>
        </div>
        <div className="mt-4 block lg:hidden">
          <Divider />
        </div>
        <div className="w-full mt-4 flex flex-col gap-6 border border-[#e1f7ff] bg-[#e1f7ff] px-[8px] py-[8px] rounded-[24px] lg:flex-row-reverse lg:mt-8 lg:items-center lg:gap-5 ">
          <div className="w-full h-[91px] lg:w-[240px] lg:h-[200px] lg:shadow-custom lg:rounded-full lg:flex lg:items-center lg:justify-center mt-4 rounded-[20px] flex items-center justify-center border border-solid border-[#F1F0F0] bg-white">
            <img src={vinh_phu} alt="vp" className="max-w-full h-auto" />
          </div>
          <div className="w-full">
            <p className="text-base md:text-lg lg:text-xl font-semibold text-[#1375B7]">
              CÔNG TY CỔ PHẦN THƯƠNG MẠI NGÔI SAO VĨNH PHÚ
            </p>
            <p className="text-sm md:text-base text-[#333333] font-normal">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ac
              congue elit. Pellentesque quis feugiat ex. Pellentesque ac elit at
              quam porttitor mollis. Aliquam pretium vitae lectus quis pretium.
              Vestibulum vitae finibus turpis. Nulla venenatis vulputate velit
              eget lobortis. Phasellus cursus posuere nunc, et malesuada mauris
              porta a. Nunc semper odio eros, non ultrices lorem posuere eget.
              Curabitur tempus odio non sagittis posuere. Pellentesque in
              posuere ipsum, interdum cursus lectus.{" "}
            </p>
          </div>
        </div>
        <div className="mt-4 block lg:hidden">
          <Divider />
        </div>
        <div className="w-full flex flex-col gap-6 lg:flex-row lg:mt-8 lg:items-center lg:gap-5">
          <div className="w-full h-[91px] lg:w-[600px]  lg:h-[200px] lg:shadow-custom lg:rounded-full lg:flex lg:items-center lg:justify-center mt-4 rounded-[20px] flex items-center justify-center border border-solid border-[#F1F0F0] bg-white">
            <img src={vinh_phu} alt="vp" className="max-w-full h-auto" />
          </div>
          <div>
            <p className="text-base md:text-lg lg:text-xl font-semibold text-[#1375B7]">
              CÔNG TY CỔ PHẦN THƯƠNG MẠI NGÔI SAO VĨNH PHÚ
            </p>
            <p className="text-sm md:text-base text-[#333333] font-normal">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. In ac
              congue elit. Pellentesque quis feugiat ex. Pellentesque ac elit at
              quam porttitor mollis. Aliquam pretium vitae lectus quis pretium.
              Vestibulum vitae finibus turpis. Nulla venenatis vulputate velit
              eget lobortis. Phasellus cursus posuere nunc, et malesuada mauris
              porta a. Nunc semper odio eros, non ultrices lorem posuere eget.
              Curabitur tempus odio non sagittis posuere. Pellentesque in
              posuere ipsum, interdum cursus lectus.{" "}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
